export const SECTION_ORDER = [
    'main',
    'physical',
    'design',
    'paper',
    'specimen',
    'notes',
];
export class MetaError extends Error {
}
export function findItemType(meta, typeCode) {
    const type = meta.itemTypes.find((t) => t.code === typeCode);
    if (!type)
        throw new MetaError(`Неизвестный тип объекта: ${typeCode}`);
    return type;
}
export function fieldIndex(meta) {
    return new Map(meta.fields.map((f) => [f.code, f]));
}
/**
 * Поля типа для уровня заполнения, в порядке отображения.
 * Для экземпляра — его собственные поля плюс поля каталога/разновидности как необязательные
 * переопределения (docs/PLAN.md, раздел 4.3: resolveSpecimen накладывает слои).
 */
export function fieldsForType(meta, typeCode, level) {
    const type = findItemType(meta, typeCode);
    const defs = fieldIndex(meta);
    const result = [];
    for (const link of type.fields) {
        const def = defs.get(link.field);
        if (!def)
            throw new MetaError(`Тип ${typeCode} ссылается на неизвестное поле ${link.field}`);
        const own = def.levels.includes(level);
        const override = level === 'specimen' && !own;
        if (!own && !override)
            continue;
        result.push({
            def,
            required: own && link.required,
            section: link.section,
            sortKey: link.sortKey,
            override,
        });
    }
    return result.sort((a, b) => SECTION_ORDER.indexOf(a.section) - SECTION_ORDER.indexOf(b.section) ||
        a.sortKey.localeCompare(b.sortKey));
}
//# sourceMappingURL=meta.js.map